import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import cookie from '@/common/utils/cookie'
import { MENU, MULTI_SECTION_LIST_ACTIONS, SET_CURRENT_GNB, SET_CURRENT_MENU, UI_CODE } from '@/common/resources/const'
import { getServiceLocationInfo, setServiceLocationInfo } from '@/common/utils/common'
import _ from 'lodash'
import { setReferer } from '@/common/utils/referer'
import { getServiceLocation } from '@/common/utils/request'

if (!process || process.env.NODE_ENV !== 'test') { Vue.use(Router) }

const beforeGNBEnter = (to, from, next) => {
  store.commit(SET_CURRENT_GNB, to.name)
  if (to.name !== '') {
    store.commit(SET_CURRENT_MENU, to.name)
  }
  next()
  const force = !!(to.name === MENU.HOME || to.name === MENU.LIVE)
  store.dispatch(MULTI_SECTION_LIST_ACTIONS.FETCH, { gnbName: to.name, force }).then(() => {
  })
}

const beforeEnterNeedAdultCheckPage = (to, from, next) => {
  if (from.name !== 'login' && from.name !== 'profile_list' && from.name !== 'adult') {
    setReferer(from.fullPath)
  }
  next()
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components: {
        mainLayout: () => import('@/pages/section/MainLayout')
      },
      children: [
        {
          path: '',
          name: MENU.HOME,
          meta: { uiCode: UI_CODE.HOME, section: MENU.HOME },
          alias: 'index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "home" */'@/pages/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: 'vod',
          name: MENU.BROADCAST,
          meta: { uiCode: UI_CODE.BROADCAST, section: MENU.BROADCAST },
          alias: '/vod/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "vod" */'@/pages/vod/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: 'live',
          name: MENU.LIVE,
          meta: { uiCode: UI_CODE.LIVE, section: MENU.LIVE },
          alias: '/live/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "live" */'@/pages/live/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: 'movie',
          name: MENU.MOVIE,
          meta: { uiCode: UI_CODE.MOVIE, section: MENU.MOVIE },
          alias: '/movie/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "movie" */'@/pages/movie/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: '/global',
          name: MENU.GLOBAL,
          meta: { uiCode: UI_CODE.GLOBAL, section: MENU.GLOBAL },
          alias: '/global/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "global" */'@/pages/global/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: 'playy',
          name: MENU.PLAYY,
          meta: { uiCode: UI_CODE.PLAYY, section: MENU.PLAYY },
          alias: '/movie/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "movie" */'@/pages/movie/index')
          },
          beforeEnter: beforeGNBEnter
        },
        {
          path: 'index',
          name: 'hoem_redirect',
          redirect: () => {
            return { name: 'home', meta: { uiCode: UI_CODE.HOME, section: MENU.HOME } }
          }
        },
        {
          path: 'list/:uiCode',
          name: MENU.LIST,
          components: {
            bodyContent: () => import(/* webpackChunkName: "viewMoreList" */'@/pages/list/index')
          },
          props: true,
          beforeEnter: beforeEnterNeedAdultCheckPage
        },
        { // TODO: 오픈뒤에 URL 정리 해야 함 지금 은 실서버데이터를 바꾸면 기존 서비스에서 에러가 날 수 있으나 임시로 처리
          path: '/movie/theme-contents',
          alias: '/movie/theme-contents.html',
          name: 'theme-movie',
          beforeEnter (to, from, next) {
            next('/list/EN' + to.query.themeid)
          }
        },
        {
          path: '/vod/theme-contents',
          alias: '/vod/theme-contents.html',
          name: 'theme-vod',
          beforeEnter (to, from, next) {
            next('/list/EN' + to.query.themeid)
          }
        },
        {
          path: 'category/:id',
          name: 'categorySearch',
          components: {
            bodyContent: () => import(/* webpackChunkName "categorySearch" */'@/pages/list/Category')
          },
          props: true
        },
        {
          path: 'mypooq',
          components: {
            myPooqLayout: () => import('@/pages/section/MyPooqLayout')
          },
          children: [
            {
              path: 'use_list_vod_history',
              name: 'use_list_vod_history',
              meta: { menu: 'history', subMenu: 'vod' },
              alias: 'use_list_vod_history.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "use_list_vod_history" */'@/pages/mypooq/use_list_vod_history')
              }
            },
            {
              path: 'use_list_movie_history',
              name: 'use_list_movie_history',
              meta: { menu: 'history', subMenu: 'movie' },
              alias: 'use_list_movie_history.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "use_list_movie_history" */'@/pages/mypooq/use_list_movie_history')
              }
            },
            {
              path: 'use_list_download',
              name: 'use_list_download',
              meta: { menu: 'history', subMenu: 'download' },
              alias: 'use_list_download.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "use_list_download" */'@/pages/mypooq/use_list_download')
              }
            },
            {
              path: 'taste_analysis',
              name: 'taste_analysis',
              meta: { menu: 'taste', subMenu: '' },
              alias: 'taste_analysis.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "taste_analysis" */'@/pages/mypooq/taste_analysis')
              }
            },
            {
              path: 'like_channel',
              name: 'like_channel',
              meta: { menu: 'like', subMenu: 'channel' },
              alias: 'like_channel.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "like_channel" */'@/pages/mypooq/like_channel')
              }
            },
            {
              path: 'like_theme',
              name: 'like_theme',
              meta: { menu: 'like', subMenu: 'theme' },
              alias: 'like_theme.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "like_theme" */'@/pages/mypooq/like_theme')
              }
            },
            {
              path: 'like_program',
              name: 'like_program',
              meta: { menu: 'program', subMenu: 'program' },
              alias: 'like_program.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "like_program" */'@/pages/mypooq/like_program')
              }
            },
            {
              path: 'like_movie',
              name: 'like_movie',
              meta: { menu: 'movie', subMenu: 'movie' },
              alias: 'like_movie.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "like_movie" */'@/pages/mypooq/like_movie')
              }
            },
            {
              path: 'reserve_watch',
              name: 'reserve_watch',
              meta: { menu: 'reserve', subMenu: '' },
              alias: 'reserve_watch.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "reserve_watch" */'@/pages/mypooq/reserve_watch')
              }
            },
            {
              path: 'voucher_list_singular',
              name: 'voucher_list_singular',
              meta: { menu: 'voucher', subMenu: 'singular' },
              alias: 'voucher_list_singular.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "voucher_list_singular" */'@/pages/mypooq/voucher_list_singular')
              }
            },
            {
              path: 'voucher_list_package',
              name: 'voucher_list_package',
              meta: { menu: 'voucher', subMenu: 'package' },
              alias: 'voucher_list_package.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "voucher_list_package" */'@/pages/mypooq/voucher_list_package')
              }
            },
            {
              path: 'subscription_ticket',
              name: 'subscription_ticket',
              meta: { menu: 'subscription', subMenu: 'ticket' },
              alias: 'subscription_ticket.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "subscription_ticket" */'@/pages/mypooq/subscription_ticket')
              }
            },
            {
              path: 'coin',
              name: 'coin',
              meta: { menu: 'coin_coupon', subMenu: 'coin' },
              alias: 'coin.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "coin" */'@/pages/mypooq/coin')
              }
            },
            {
              path: 'coupon',
              name: 'coupon',
              meta: { menu: 'coin_coupon', subMenu: 'coupon' },
              alias: 'coupon.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "coupon" */'@/pages/mypooq/coupon')
              }
            },
            {
              path: 'user_qna',
              name: 'user_qna',
              meta: { menu: 'user_qna', subMenu: '' },
              alias: 'user_qna.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "user_qna" */'@/pages/mypooq/user_qna')
              }
            },
            {
              path: 'user_qna_view',
              name: 'user_qna_view',
              meta: { menu: 'user_qna', subMenu: '' },
              alias: 'user_qna_view.html',
              components: {
                myPooqContent: () => import(/* webpackChunkName: "user_qna_view" */'@/pages/mypooq/user_qna_view')
              }
            }
          ],
          beforeEnter: (to, from, next) => {
            if (cookie.getCredential() === 'none') {
              next({ path: `/member/login?referer=${to.fullPath}`, replace: true })
            } else {
              next()
            }
          }
        },
        {
          path: 'voucher',
          components: {
            voucherLayout: () => import('@/pages/section/VoucherLayout')
          },
          children: [
            {
              path: 'index',
              name: 'voucher_index',
              meta: { menu: 'index' },
              alias: 'index.html',
              components: {
                voucherContent: () => import(/* webpackChunkName: "voucher_index" */'@/pages/voucher/index')
              }
            },
            {
              path: 'regist',
              name: 'voucher_regist',
              meta: { menu: 'regist' },
              alias: 'regist.html',
              components: {
                voucherContent: () => import(/* webpackChunkName: "voucher_regist" */'@/pages/voucher/regist')
              }
            },
            {
              path: 'wavveon',
              name: 'voucher_pooqzone',
              meta: { menu: 'wavveon' },
              alias: 'wavveon.html',
              components: {
                voucherContent: () => import(/* webpackChunkName: "voucher_pooqzone" */'@/pages/voucher/pooqzone')
              }
            },
            {
              path: 'promotion',
              name: 'voucher_promotion',
              meta: { name: 'voucher_promotion' },
              alias: 'promotion.html',
              components: {
                voucherContent: () => import(/* webpackChunkName: "voucher_promotion" */'@/pages/voucher/voucher_promotion')
              }
            },
            { path: 'pooqzone', redirect: '/voucher/wavveon' },
            { path: 'pooqzone.html', redirect: '/voucher/wavveon' }
          ]
        },
        {
          path: '/schedule',
          name: 'schedule',
          alias: '/schedule/index.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "schedule" */'@/pages/schedule/index')
          }
        },
        {
          path: '/search/search',
          name: 'search',
          alias: '/search/search.html',
          components: {
            searchContent: () => import(/* webpackChunkName: "search" */'@/pages/search/Search')
          }
        },
        {
          path: '/search/search_tag',
          name: 'search_tag',
          alias: '/search/search_tag.html',
          components: {
            searchContent: () => import(/* webpackChunkName: "search_tag" */'@/pages/search/search_tag')
          }
        },
        {
          path: '/search/search_tag_group',
          name: 'search_tag_group',
          alias: '/search/search_tag_group.html',
          components: {
            searchContent: () => import(/* webpackChunkName: "search_tag_group" */'@/pages/search/search_tag_group')
          }
        },
        {
          path: 'customer',
          components: {
            customerLayout: () => import('@/pages/section/CustomerSupportLayout')
          },
          children: [
            {
              path: 'notice_list',
              name: 'notice_list',
              meta: { tab: 'notice', type: 'notice' },
              alias: 'notice_list.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "notice_list" */'@/pages/customer/notice_list')
              }
            },
            {
              path: 'notice_view',
              name: 'notice_view',
              meta: { tab: 'notice', type: 'notice' },
              alias: 'notice_view.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "notice_view" */'@/pages/customer/notice_view')
              }
            },
            {
              path: 'faq',
              name: 'faq',
              meta: { tab: 'faq', type: 'notice' },
              alias: 'faq.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "faq" */'@/pages/customer/faq')
              }
            },
            {
              path: 'agreement',
              name: 'agreement',
              meta: { tab: 'agreement', type: 'notice' },
              alias: 'agreement.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "agreement" */'@/pages/customer/agreement')
              }
            },
            {
              path: 'event_list',
              name: 'event_list',
              meta: { menu: 'event', type: 'event' },
              alias: 'event_list.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "event_list" */'@/pages/customer/event_list')
              }
            },
            {
              path: 'event_view',
              name: 'event_view',
              meta: { menu: 'event', type: 'event' },
              alias: 'event_view.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "event_view" */'@/pages/customer/event_view')
              }
            },
            {
              path: 'event_board_list',
              name: 'event_board_list',
              meta: { menu: 'board', type: 'event' },
              alias: 'event_board_list.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "event_board_list" */'@/pages/customer/event_board_list')
              }
            },
            {
              path: 'event_board_view',
              name: 'event_board_view',
              meta: { menu: 'board', type: 'event' },
              alias: 'event_board_view.html',
              components: {
                customerContent: () => import(/* webpackChunkName: "event_board_view" */'@/pages/customer/event_board_view')
              }
            }
          ]
        },
        {
          path: '/agreement/:section',
          name: 'customer_agreement_redirect',
          redirect: (to) => {
            if (to.params.section === 'service') {
              return { name: 'agreement', query: { category: 'service' } }
            } else if (to.params.section === 'privacy') {
              return { name: 'agreement', query: { category: 'privacy' } }
            } else if (to.params.section === 'paid') {
              return { name: 'agreement', query: { category: 'payment' } }
            } else if (to.params.section === 'youth') {
              return { name: 'agreement', query: { category: 'youth' } }
            } else if (to.params.section === 'pooqzone') {
              return { name: 'agreement', query: { category: 'pooqzone' } }
            }
          }
        },
        {
          path: '/event/list',
          name: 'event_list_redirect',
          redirect: () => {
            return { name: 'event_list', meta: { menu: 'event', type: 'event' } }
          }
        },
        {
          path: '/event/detail/:section',
          name: 'event_detail_redirect',
          redirect: (to) => {
            return {
              name: 'event_view',
              query: { eventId: to.params.section, prevPage: 1 },
              meta: { menu: 'event', type: 'event' }
            }
          }
        },
        {
          path: '/event/board',
          name: 'event_board_list_redirect',
          redirect: () => {
            return { name: 'event_board_list', meta: { menu: 'board', type: 'event' } }
          }
        },
        {
          path: '/event/board/:section',
          name: 'event_board_view_redirect',
          redirect: (to) => {
            return {
              name: 'event_board_view',
              query: { eventId: to.params.section, pageNum: 1 },
              meta: { menu: 'board', type: 'event' }
            }
          }
        },
        {
          path: '/login',
          name: 'login_redirect',
          redirect: () => {
            return { name: 'login' }
          }
        },
        {
          path: '/clip/index.html',
          name: 'clip_redirect_html',
          redirect: () => {
            return { name: 'global' }
          }
        },
        {
          path: '/clip/index',
          name: 'clip_redirect',
          redirect: () => {
            return { name: 'global' }
          }
        },
        {
          path: '/customer/business',
          name: 'business',
          alias: '/customer/business.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "business" */'@/pages/customer/business')
          }
        },
        {
          path: '/customer/recruit',
          name: 'recruit',
          alias: '/customer/recruit.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "recruit" */'@/pages/customer/recruit')
          }
        },
        {
          path: '/customer/company',
          name: 'company',
          alias: '/customer/company.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "company" */'@/pages/customer/company')
          }
        },
        {
          path: '/customer/service',
          name: 'service',
          alias: '/customer/service.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "service" */'@/pages/customer/service')
          }
        },
        {
          path: 'player/vod',
          name: 'player_vod',
          meta: { section: 'vod' },
          alias: '/player/vod.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "player_vod" */'@/pages/player/vod')
          },
          beforeEnter: (to, from, next) => {
            if (from.name !== 'login' && from.name !== 'profile_list') {
              setReferer(from.fullPath)
            }
            next()
          }
        },
        {
          path: '/player/live',
          name: 'player_live',
          meta: { section: 'live' },
          alias: '/player/live.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "player_live" */'@/pages/player/live')
          }
        },
        {
          path: '/player/movie',
          name: 'player_movie',
          meta: { section: 'movie' },
          alias: '/player/movie.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "player_movie" */'@/pages/player/movie')
          },
          beforeEnter: beforeEnterNeedAdultCheckPage
        },
        {
          path: '/player/clip',
          name: 'player_clip',
          meta: { section: 'clip' },
          alias: '/player/clip.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "player_clip" */'@/pages/player/clip')
          }
        },
        {
          path: '/member/login',
          name: 'login',
          meta: { menuIndex: 0 },
          alias: '/member/login.html',
          components: {
            bodyContent: () => import(/* webpackChunkName: "login" */'@/pages/member/login')
          }
        }
      ]
    },
    { path: '/member', redirect: '/member/login.html' },
    {
      path: '/member/profile_list',
      name: 'profile_list',
      alias: '/member/profile_list.html',
      components: {
        member: () => import(/* webpackChunkName: "profile_list" */'@/pages/member/profile_list')
      }
    },
    {
      path: '/member/profile_edit',
      name: 'profile_edit',
      alias: '/member/profile_edit.html',
      components: {
        member: () => import(/* webpackChunkName: "profile_edit" */'@/pages/member/profile_edit')
      }
    },
    {
      path: '/member/profile_change',
      name: 'profile_change',
      alias: '/member/profile_change.html',
      components: {
        member: () => import(/* webpackChunkName: "profile_change" */'@/pages/member/profile_change')
      }
    },
    {
      path: '/member/member_login.html',
      name: 'member_login',
      components: {
        member: () => import(/* webpackChunkName: "member_login" */'@/pages/member/member_login')
      }
    },
    {
      path: '/wavveon',
      name: 'wavveon_intro',
      alias: '/wavveon.html',
      components: {
        wavveon: () => import('@/pages/wavveon')
      }
    },
    {
      path: '/adult',
      name: 'adult',
      alias: '/player/adult.html',
      components: {
        adult: () => import('@/pages/player/adult')
      }
    },
    {
      path: '/voucher/popup',
      name: 'popup_voucher',
      alias: '/voucher/popup.html',
      components: {
        voucher_popup: () => import(/* webpackChunkName: "popup_voucher" */'@/pages/voucher/popup')
      }
    },
    {
      path: '/voucher/revocation_defense',
      name: 'revocation_defense',
      alias: '/voucher/revocation_defense.html',
      components: {
        voucher_popup: () => import(/* webpackChunkName: "revocation_defense" */'@/pages/voucher/revocation_defense')
      }
    },
    {
      path: '/voucher/recommend.html',
      redirect: () => {
        return '/voucher/index'
      }
    },
    {
      path: '/tlogincallback.html',
      name: 'tlogincallback',
      components: {
        callback: () => import(/* webpackChunkName: "tcallback" */'@/pages/callback/TloginCallback')
      }
    },
    {
      path: '/under_construction',
      name: 'construction',
      components: {
        construction: () => import(/* webpackChunkName: "under_construction" */'@/pages/under_construction')
      }
    },
    {
      path: '/waiting/service',
      name: 'waitingService',
      components: {
        waiting: () => import(/* webpackChunkName: "waiting" */'@/pages/wating_service')
      }
    },
    {
      path: '/wavvie_popup',
      name: 'wavvie_popup',
      components: {
        wavvie_popup: () => import('@/components/common/WavviePopup')
      }
    },
    {
      path: '/event/index',
      name: 'event_emergency',
      alias: '/event/index.html',
      components: {
        event_emergency: () => import('@/pages/event/index')
      }
    },
    {
      path: '*',
      name: 'error',
      components: {
        notfound: () => import(/* webpackChunkName: "notfound" */'@/pages/error')
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isService = _.get(getServiceLocationInfo(), 'isservice', 'y') === 'y'
  if (to.name === 'waitingService') { next() } else if (!isService) {
    next('/waiting/service')
  } else {
    // INFO: AZURE 이관 관련하여 방어 코드 자동로그인을 했으나 브라우저를 종료하여 sessionStorage 의 값이 없는 경우를 산성
    const locationInfo = getServiceLocationInfo()
    const credential = cookie.getCredential()
    if (locationInfo === null && credential !== 'none') {
      console.log('<---EMPTY--- Location Info --- has Credentail ------>')
      getServiceLocation(credential).then((serviceLocation) => {
        const locationInfo = _.get(serviceLocation, ['data'], false)
        if (locationInfo) {
          setServiceLocationInfo(locationInfo)
          next()
        }
      })
    } else {
      next()
    }
  }
})

export default router
